import React from 'react';

const Requirements = () => {
  return (
    <section id="requirements">
      <div className="container">
        <h2 className="section-title">Syarat & Ketentuan</h2>
        <div className="requirements">
          <h3>Persyaratan Umum</h3>
          <ul>
            <li>Mempunyai KTP (minimal 18 tahun)</li>
            <li>Mempunyai Rekening Bank</li>
            <li>Ramah dan komunikatif</li>
            <li>Tidak malu di depan kamera</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Requirements;
